module.exports = __webpack_public_path__ + "static/media/Logo4aWhite.be8c7cd5.png";